<div class="table-responsive" [ngClass]="{'sk-loading': propertyService.spinnerShow}" [class.overflow-hidden]="propertyService.emptyRowService.emptyRow.length > 0">
    <table class="table table-striped table-hover footable" *ngIf="propertyService.data.length">
        <thead>
            <tr [ngClass]="{'noSort': propertyService.data.length < 2}">
                <th style="width: 50px;"></th>
                <th class="footable-sorted">
                    <span>ID #</span>
                </th>
                <th (click)="propertyService.urlService.orderBy('name', $event)">
                    <span>Property group name</span>
                    <span class="footable-sort-indicator"></span>
                </th>
                <th (click)="propertyService.urlService.orderBy('id', $event)">
                    <span>Buildings</span>
                    <span class="footable-sort-indicator"></span>
                </th>
                <th>
                    <span>Property Mgmt</span>
                </th>
                <th *ngIf="propertyService.canDelete() && propertyService.account.isUserAdmin()">Actions</th>
            </tr>
        </thead>

        <tbody>
            <tr *ngFor="let item of propertyService.data" [ngClass]="{'footable-odd': (index % 2 === 0)}" (click)="toggleDetails(item)">
                <td>
                    <label class="img-checkbox">
                        <input type="checkbox" [ngModel]="item.checked">
                        <label><svg-checked></svg-checked></label>
                    </label>
                </td>
                <td>
                    <span>{{item.id || '-'}}</span>
                </td>
                <td>
                    <span>{{item.name}}</span>
                </td>
                <td>
                    <relation-list keyTitle="name"
                                   other="-"
                                   [items]="propertyService.buildingsList"
                                   [values]="item.buildings ? item.buildings : []">
                    </relation-list>
                </td>
                <td>
                    <relation-list keyTitle="name"
                                   other="-"
                                   [items]="propertyService.companies"
                                   [values]="[item.companyId]">
                    </relation-list>
                </td>
                <td class="td-action-btn" *ngIf="propertyService.account.isUserAdmin()">
                    <div class="input-group-btn btn-in-table input-group">
                        <button (click)="editBuildings(item)" class="btn btn-white btn-xs sign-out-return-buttons">Edit</button>
                        <button data-toggle="dropdown" class="btn btn-white dropdown-toggle btn-xs"
                                aria-expanded="false"><span class="caret"></span></button>
                        <ul class="dropdown-menu pull-right">
                            <li (click)="removeItem(item)"><a>Delete</a></li>
                        </ul>
                    </div>
                </td>
            </tr>

            <tr *ngFor="let item of propertyService.emptyRowService.emptyRow" style="cursor: default;">
                <td>&nbsp;</td>
                <td></td>
                <td></td>
                <td></td>
                <td></td>
                <td *ngIf="propertyService.canDelete() && propertyService.account.isUserAdmin()"></td>
            </tr>
        </tbody>
    </table>
    <div *ngIf="propertyService.total === 0" class="text-center">
        <h2>Result Not Found</h2>
        <a class="text-center">
            <broad-match-toggle></broad-match-toggle>
        </a>
    </div>
    <spinner [spinnerShow]="propertyService.spinnerShow"></spinner>
</div>



// WEBPACK FOOTER //
// /app/src/app/views/admin/property/property-group-list/property-group-list.component.html